module.exports = __webpack_public_path__ + "static/img/about-header@2x.61b9b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-header@2x.png
// module id = waeo
// module chunks = 12